export const ar = {
  language: "العربيه",
  "general": {
    "Rights": "جميع الحقوق محفوظة",
    "nanoSoft": "نانوسوفت",
      "Readytoarchitectyournextbreakthrough":"هل أنت مستعد لتصميم إنجازك القادم؟",
  "GetAFreeConsultation":"احصل على استشارة مجانية",
  "allProjects": "جميع المشاريع",
  "aiProjects": "مشاريع الذكاء الاصطناعي",
  "webInfrastructure": "البنية التحتية للويب",
  "mobile": "الجوال",
  "systems": "الأنظمة",
  "interactiveVideos": "الفيديوهات التفاعلية",
    "portfolioParagraph":"نحن نبني البنية التحتية غير المرئية التي تدعم الحدود الرقمية. من البنية التحتية عالية التوافر إلى التكامل العصبي، تحدد أعمالنا معيار هندسة البرمجيات الحديثة.",
    "portfolioTitle":"ملف أعمال هندسية.",
      "Execution":"تنفيذ دقيق",
"view":"عرض",
  videoDesc: "تصميم تجربة فيديو تفاعلية غامرة تزيد من تفاعل المستخدمين وتشجعهم على استكشاف المحتوى.",
  attendanceSystemDesc: "تطوير نظام حضور وانصراف متكامل مع مزامنة فورية وتقليل الأخطاء اليدوية بنسبة كبيرة.",
  restaurantSystemDesc: "تطوير نظام ذكي لإدارة المطاعم والطلبات والطاولات وخدمات التوصيل.",
  policeAcademyDesc: "تطوير منصة رقمية لأكاديمية الشرطة في سلطنة عمان.",
  aiAcademyDesc: "تطوير منصة أكاديمية مدمجة مع شات بوت بالذكاء الاصطناعي.",
  universityDesc: "تطوير منصة جامعية حديثة للجامعة العربية المفتوحة في سلطنة عمان.",
  storeDesc: "تطوير متجر إلكتروني احترافي بتجربة مستخدم عصرية.",
  realEstateDesc: "تطوير منصة عقارية لعرض المشاريع والعقارات بشكل احترافي.",
  marriageAppDesc: "تطوير تطبيق زواج وتواصل اجتماعي حديث للهواتف الذكية.",
   "home": "الرئيسية",
    "about": "من نحن",
    "services": "خدماتنا",
    "wordpress":"ورد بريس",
    "contact": "تواصل بنا",
    "aboutParag": "نانوسوفت هي شركة تطوير برمجيات في الاسكندرية مصر ، التي توفر لعملائها مجموعه كاملة من خدمات البرمجيات مع التركيز علي تطوير الويب ، وتصميم المواقع ، وتطوير تطبيقات الجوال واختبار البرمجيات",
    "quickLinks": "روابط سريعة",
    "Contact Us": "بيانات التواصل",
    "ourServices": "خدماتنا",
    "wordpressText":"لو بتخطط تطلق متجرك الإلكتروني على وردبريس، فهنا بداية الطريق الصح في  نانوسوفت نجهّز لك متجر متكامل يشيل عنك التعب من أول إعداد لحد ما تكون جاهز للبيع بثقة وشكل محترم يليق بمشروعك.",
    "websiteDevelopment": "برمجة المواقع الإلكترونية",
    "appDeveloper": "برمجةو تصميم تطبيقات الجوال ",
    "userExp": "تصميم تجربة المستخدم و واجهات تطبيقات الجوال",
    "aboutDes": "نسعى لتحقيق افضل النتائج في كافة المجالات التي نقدمها وبأعلى مستوى من خلال فريق عمل محترف ومختص يعمل على تظافر جهوده وخبراته ومواهبه ليسخرها في تقديم أفضل الخدمات وتحقيق أهداف وغايات العملاء حيث نقوم بتقديم خدماتنا لكافة دول العالم وبأسعار مدروسة تناسب الجميع",
    "istanbul": "الاسكندرية",
    "turkey": "مصر",
    "webDesc": "برمجة وتصميم المواقع الإلكترونية هي بوابتك لبدأ نشاطك التجاري على الانترنت هل ترغب في نقل عملك إلى مستوى أعلى؟ هل ترغب في الحصول على المزيد من العملاء؟ هل تعرف أن أكثر من 90٪ من الأشخاص يستخدمون الإنترنت للعثور على ما يحتاجون إليه؟ فماذا تنتظر؟ اتصل بنا وسنقوم ببناء موقع الويب المذهل الذي يناسب عملك وسنظل بجانبك لتقديم الدعم لك.",
    "appDesc": "برمجة وتصميم تطبيقات الموبايل تساعدك على الوصول لعملائك بسهولة، فمع استخدام أغلب الناس للهواتف الذكية يوميًا أصبح التطبيق وسيلة فعالة لزيادة التفاعل والمبيعات. نحن نوفر لك دراسة الفكرة، التخطيط، تحديد المتطلبات، والبرمجة باحترافية لتنفيذ تطبيقك بأفضل جودة.",
    "userDesc": "نقدم خدمة النماذج الأولية و تصميم واجهات تطبيقات الجوال والمواقع الإلكترونية لمنتجات الويب والجوال. كما نركز على تقديم تجربة عملاء استثنائية ، حيث نملك فريق موهوب ومتخصص في تصميم واجهات تطبيقات الهاتف الجوال والمواقع الإلكترونية.",
    "vision": "رؤيتنا",
    "portfolio":"أعمالنا",
    "visionDesc": "تأسست شركة نانوسوت على الريادة وتطوير الأفكار الأبداعية على مستوى العالم لتكون منصة انطلاقة حقيقية تدفع بالعملاء الى الاحترافية التامة في العمل وفق فريق مهندسين متخصص ومتنوع في كافة مجالات الانترنت وبأعلى مستوى، حيث نتكافل ونتعاون لجعل مواهبنا وخبراتنا في خدمة العملاء لتلبية كافة طلباتهم على أسس متقدمة",
    "goal": "هدفنا",
    "goalDesc": "أن تصبح شركة نانوسوفت  من افضل الشركات الرائدة في مجال الخدمات البرمجيه.",
    "message": "رسالتنا",
    "messageDesc": "تم تأسيس هذه الشركة على أساس من الابداع الخالص المستند على أهم القواعد والخبرات العلمية والعملية لأننا نطمح إلى التميز والارتقاء في جميع جوانب خدماتنا لكي نقدم أفضل الخدمات لعملائنا و نجسد إنجازاتنا على أرض الواقع، لنكون علماً من أعلام التسويق الإلكتروني والبرمجيات على مستوى العالم فالريادة هي هدفنا والتميز والإبداع غايتنا.",
    "value": "قيمتنا",
    "valueDesc": "استقينا قيمنا من التزامنا بأمانتنا تجاه وطننا ونهضتة وعملائنا ومنسوبينا وشركائنا, والتي تتمثل في التفاني والاتقان في اعمالنا، المصداقية والشفافية في تعاملاتنا والجودة والتميز والابداع في خدماتنا.",
    "headerTitle":"تطبيقات الجوال والمواقع الإلكترونية",
    "headerPara":"إنشاء جميع أنواع التطبيقات والمواقع الإلكترونية بأسلوب عصرى مع التركيز على متطلبات العملاء بالتوافق مع وضوح واجهة المستخدم / تجربة المستخدم.    ",
    "coursesTitle":"الكورسات",
    "partnersTitle":"شركاؤنا ",
    "Growth":"نمو شركتنا",
    "project":"مشاريع",
                     "countries":"بلاد",
                     "ourfeatures":"مميزاتنا",
                     "featureone":"فريقنا جاهز للإجابة على جميع استفساراتك بلا أي رسوم.",
                     "featureTwo":"نحن هنا لدعمك خطوة بخطوة دون أي تكلفة إضافية.",
                     "featureThree":"سواءً كنت عميل جديد أو قديم، الدعم الفني لدينا مجاني للجميع.",
                     "networkSecurty":"أمن الشبكات"

  }
}